import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BizCategoryState } from './biz-category.reducer';

// Selector to get the "bizCategory" feature state
export const selectBizCategoryState = createFeatureSelector<BizCategoryState>('bizCategory');

// Selector to get all community biz category data
export const selectAllBizCategory = createSelector(
  selectBizCategoryState,
  (state: BizCategoryState) => state.bizCategory
);

// Selector to get the loading state
export const selectLoading = createSelector(
  selectBizCategoryState,
  (state: BizCategoryState) => state.loading
);
